import React from "react";
import { Quote } from "lucide-react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { TESTIMONIALS } from "../../data/content";
import { useSiteContent } from "../../context/SiteContentContext";
import { CardSkeleton } from "./Skeletons";

export const Testimonials = () => {
  const { testimonials, loading } = useSiteContent();
  return (
    <Section id="testimonials" glow>
      <SectionHeading overline={TESTIMONIALS.overline} title={TESTIMONIALS.title} intro={TESTIMONIALS.intro} />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {loading
          ? Array.from({ length: 3 }).map((_, i) => <CardSkeleton key={i} h="h-8" />)
          : testimonials.map((item, i) => {
              const t = item.data;
              return (
          <Reveal key={item.id} delay={i * 0.08} className="rounded-3xl border border-white/5 bg-white/[0.015] p-8 flex flex-col">
            <Quote className="h-7 w-7 text-brand/60 mb-6" strokeWidth={1.5} />
            <p className="font-heading text-lg font-light leading-relaxed text-white/90 flex-1">
              “{t.quote}”
            </p>
            <div className="mt-8 flex items-center gap-3 pt-6 border-t border-white/5">
              <img src={t.avatar} alt={t.name} loading="lazy" className="h-10 w-10 rounded-full object-cover grayscale" />
              <div>
                <div className="text-sm text-white">{t.name}</div>
                <div className="text-xs text-muted-foreground">{t.role}</div>
              </div>
            </div>
          </Reveal>
              );
            })}
      </div>
    </Section>
  );
};

export default Testimonials;
